import { PropsWithChildren } from "react";

export function Sidebar({ children }: PropsWithChildren<NonNullable<unknown>>) {
  return <aside className="w-[300px] flex flex-col flex-shrink-0 gap-4">{children}</aside>;
}

export function ColumnSeparator() {
  return <div className="flex border-l self-stretch" />;
}
